import React, {useEffect} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import SectionEditPage from 'pages/SectionEditPage';
import WebEditPage from 'pages/WebEditPage';
import NoMatchPage from 'pages/NoMatchPage';
import emoticonSDK, {BuildEnvironment} from '@soopkr-fe/emoticon-sdk';
import {HOST} from 'constants/config';

const App: React.FC = () => {
  useEffect(() => {
    // 이모티콘 sdk 초기화
    emoticonSDK.emoticons.initialize({
      hostObject: HOST,
      env: process.env.APP_ENV as BuildEnvironment,
    });
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={['/:titleNo', '/section/:titleNo']}
          component={SectionEditPage}
          exact
        />
        <Route path={'/web/:titleNo'} component={WebEditPage} />
        <Route component={NoMatchPage} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
